import { NgModule } from "@angular/core";
import { RepositoryFactoryProvider } from "../../../common/utils/backend.provider";
import { LocalStorageRepositoryInterface } from "../local-storage/local-storage.interface";
import { LoadingOverlayService } from "../../components/loading-overlay/services/loading-overlay.service";
import { RouterService } from "../../services/router.service";
import { TokenService } from "../../services/user/token.service";
import { UsersHttpBackend } from "../users/users.backend";
import { ProjectsRepositoryInterface } from "./projects.interface";
import { ProjectsRepository } from "./projects.repository";

@NgModule({
  providers: [
    RepositoryFactoryProvider({
      provide: ProjectsRepositoryInterface,
      repository: ProjectsRepository,
      backend: UsersHttpBackend,
      deps: [
        LocalStorageRepositoryInterface,
        RouterService,
        LoadingOverlayService,
        TokenService
      ]
    })
  ]
})
export class ProjectsRepositoryModule { }